import React from 'react'
import Link from 'gatsby-link'

const IndexPage = () => (
  <article className="documentation">
    <h1>
      <a href="/">Dashboard Documentation</a>
    </h1>
    <p>Welcome to the Dashboard documentation site.</p>
  </article>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.jsx